const boldParagraphClassName = 'font-bold';
const articleClassName = 'text-mainWhite text-xl flex flex-col gap-2';
const unorderedListClassName = 'flex flex-col gap-2 list-disc ms-10';

const FrequentQuestionsPage = () => {
  return (
    <div className="flex flex-col px-8 my-10 gap-10">
      <article className={articleClassName}>
        <p className={boldParagraphClassName}>Какво е Bolarena?</p>
        <p>
          Bolarena е дигитална платформа, която улеснява организацията и
          участието в спортни събития и занимания в твоя град.
        </p>
      </article>

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>Защо да използвам Bolarena?</p>
        <ul className={unorderedListClassName}>
          <li>
            Спестяваш време и средства при организиране на спортни игри и
            събития.
          </li>
          <li>
            Лесно намираш и се присъединяваш към събития и спортни групи в твоя
            район.
          </li>
          <li>
            Играчите и събитията се оценяват чрез рейтинги и коментари, което
            прави преживяването по-забавно и надеждно.
          </li>
          <li>Можеш да участваш в турнири, организирани близо до теб.</li>
        </ul>
      </article>

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>
          Мога ли да използвам Bolarena само за футбол?
        </p>
        <p>
          Засега в Bolarena можеш да организираш и участваш в спортни събития по
          футбол, а скоро и по тенис, баскетбол, волейбол и други спортове.
        </p>
      </article>

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>
          Какво представлява нивото (рангът) на играча?
        </p>
        <p>
          Нивото е числова стойност от 0 до 10, която показва активността и
          оценките на играча в платформата. Тази стойност се променя според
          резултатите, гласуванията и статистиките от игрите.
        </p>
      </article>

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>
          Мога ли да се откажа от участие в игра?
        </p>
        <p>
          Да, можеш да се откажеш в рамките на срока, посочен от организатора.
          След изтичане на срока, отмяната е невъзможна и се дължи такса за наем
          на игрището или ако има депозит се приспада.
        </p>
      </article>

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>
          Какво правя, когато списъкът с участници е пълен?
        </p>
        <p>
          Отправяй се към мястото на игра поне 10 минути предварително, носи
          подходящ спортен екип и се забавлявай с останалите. След края не
          забравяй да въведеш резултата и да дадеш обратна връзка за другите
          играчи.
        </p>
      </article>

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>
          Ако списъкът не е пълен, трябва ли да чакам до последната минута да се
          присъединя към играта?
        </p>
        <p>
          Не е необходимо да чакаш. Ако групата е отворена може да се
          присъединиш чрез заявка към капитана и съответно одобрение от негова
          страна.
        </p>
      </article>

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>
          Как да организирам спортно събитие?
        </p>
        <ul className={unorderedListClassName}>
          <li>Натисни бутона „Игрища“;</li>
          <li>
            Избери спортен комплекс и резервирай свободен ден и час за игра;
          </li>
          <li>Добави името на твоята група /ако имаш такава/;</li>
          <li>Избери дали събитието да е отворено или затворено;</li>
          <li>Потвърди.</li>
        </ul>
      </article>

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>
          Каква е разликата между отворена и затворена игра?
        </p>
        <p>
          Отворената игра е достъпна за всички потребители на платформата,
          докато затворената е достъпна само за членове на групата. Можеш да
          променяш статуса на играта по всяко време или предварително зададен
          час в настройки на групата.
        </p>
      </article>

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>
          Мога ли да изключвам участници от моите игри?
        </p>
        <p>
          Можеш да изключваш играчи, които не спазват правилата за игра,
          некоректни и са причина за отпадане на играта, но само ако си капитан
          или втори капитан на групата. Можеш също да използваш черен списък или
          да организираш частно игра с избрани потребители.
        </p>
      </article>

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>
          Мога ли да съдействам или да сътруднича с Bolarena?
        </p>
        <p>
          За въпроси и предложения можеш да се свържеш с нас през контактите,
          посочени на платформата.
        </p>
      </article>
    </div>
  );
};

export default FrequentQuestionsPage;
